import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { setRawDatasetState, setFrequencyDatasetState } from 'store/dataset';
import { setSaltMode } from 'store/mode/actions';

import { Switch, Route, Redirect } from 'react-router-dom';

import Dataset from 'scenes/Dataset';
import LinearModel from 'scenes/LinearModel';
import BootstrapCIs from 'scenes/BootstrapCIs';
import Distributions from 'scenes/Distributions';
import UnivariateSummaries from 'scenes/UnivariateSummaries';
import GraphicalStatistics from 'scenes/GraphicalStatistics';
import InferentialStatistics from 'scenes/InferentialStatistics';
import SamplingDistributions from 'scenes/SamplingDistributions';
import RandomizationHypothesisTesting from 'scenes/RandomizationHypothesisTesting';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  loadDataAsCsvFromExternalApp,
  extractDataAndAdditionalInfo
} from './helper';

import { FREQUENCY } from 'scenes/Dataset/components/constants';
import { IS_SALT_LITE } from 'store/mode/selectors';

const RemoteContainer = ({ match, history: { location: { pathname } } }) => {

  const dispatch = useDispatch();

  useEffect(() => {

    if (pathname.includes('lite')) {
      dispatch(setSaltMode(IS_SALT_LITE));
    }

    const externalCsvData = loadDataAsCsvFromExternalApp(toast);

    if (externalCsvData) {
      const { mode, data: dataset, frequencyType, frequencyColumnsName } = extractDataAndAdditionalInfo(externalCsvData);
      const nameOfDataset = 'Values From WebAssign Question';
      if (mode === FREQUENCY) {
        dispatch(setFrequencyDatasetState(dataset, frequencyType, frequencyColumnsName, nameOfDataset));
      } else {
        dispatch(setRawDatasetState(dataset, nameOfDataset));
      }

    }
  }, []);

  return (
    <main className="page-main">
      <div className="page-main__content">
        <ToastContainer />
        <Switch>
          <Route
            component={Dataset}
            path={`${match.url}/dataset`}
          />

          <Route
            component={UnivariateSummaries}
            path={`${match.url}/descriptive-statistics`}
          />

          <Route
            component={GraphicalStatistics}
            path={`${match.url}/charts-and-graphs`}
          />

          <Route
            component={Distributions}
            path={[`${match.url}/distributions`, `${match.url}/lite`]}
          />

          <Route
            component={InferentialStatistics}
            path={`${match.url}/inferential-statistics`}
          />

          <Route
            component={SamplingDistributions}
            path={`${match.url}/sampling-distributions`}
          />

          <Route
            component={BootstrapCIs}
            path={`${match.url}/bootstrap-confidence-intervals`}
          />

          <Route
            component={RandomizationHypothesisTesting}
            path={`${match.url}/randomization-hypothesis-testing`}
          />

          <Route component={LinearModel} path={`${match.url}/regression`} />

          <Redirect to={`${match.url}/dataset`} />
        </Switch>
      </div>
    </main>
  );
};

RemoteContainer.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    })
  }).isRequired
};

export default RemoteContainer;
